import { useAuth } from '../../context/AuthContext';
import { EnviosCampanaPanel } from '../EnviosCampanaPanel';
interface Props { readonly onRefresh?: () => void }
export function EnviosPendientesPanel({ onRefresh }: Props) {
  const { usuario } = useAuth();
  if (!usuario) return null;
  const rol = usuario.rol.nombre;
  if ((rol === 'user_diocesano' || rol === 'admin_diocesano') && usuario.diocesis_id) {
    return <EnviosCampanaPanel owner={{ tipo: 'diocesis', id: usuario.diocesis_id,
      nombre: 'Junta Administrativa Diocesana' }} onRefresh={onRefresh} />;
  }
  if ((rol === 'user_nacional' || rol === 'admin_nacional') && usuario.provincia_eclesiastica_id) {
    return <EnviosCampanaPanel owner={{ tipo: 'provincia', id: usuario.provincia_eclesiastica_id,
      nombre: 'Junta Administrativa Nacional' }} onRefresh={onRefresh} />;
  }
  return null;
}
